import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Input, Button, Image, Table, Select, Modal, DatePicker, message, Checkbox, QRCode, TimePicker } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { API_BASE_URL } from "../services/apiConfig";
import {API_BASE_URL_ISSUER} from "../services/apiConfig";
import InviteExcelView from "./Excel/InviteExcelView";
import InviteWaitExcelView from "./Excel/InviteWaitExcelView";
import { UploadOutlined } from '@ant-design/icons';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import * as XLSX from 'xlsx';
import AuthService from "../services/auth.service";
interface ClubInfo {

  club_seq: number;
  club_name: string;
  valid: boolean;
  club_category_seq: number;
  agentSeq: number;

}

interface InvitationView {
  SelectValue: string;
  selectedClubInfo: ClubInfo | null;
  selectmemberidsoket: any;
  onselectedDeviceNameChange: (selectedDeviceName: any) => void;
  onselectchangeupdate: (selectchangeroom: any) => void;
  profiledata: any;
}
const InvitationView: React.FC<InvitationView> = ({ SelectValue, selectedClubInfo, selectmemberidsoket, onselectedDeviceNameChange, profiledata, onselectchangeupdate }) => {
  const [invitationwaitingexcelData, setinvitationwaitingexcelData] = useState<any[]>([]);
  const [invitationwaitingexcelDatacount, setinvitationwaitingexcelDatacount] = useState<number>(0);
  const [invitationexcelData, setinvitationexcelData] = useState<any[]>([]);
  const [token, settoken] = useState<string | null>(null);
  const [selectdid, setselectdid] = useState<string>("");
  const [width, setWidth] = useState(window.innerWidth);
  const [addition, setaddition] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [verificationmodalOpen, setverificationmodalOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const [selectedRowIndex, setSelectedRowIndex] = useState<number | null>(null); //엑셀뷰 선택한 데이터 행 출력
  const [selectedRowData, setSelectedRowData] = useState<any[] | null>(null);
  const [invalidContacts, setInvalidContacts] = useState<any[]>([]);
  const [membercount, setmembercount] = useState<number>(0);
  const [verificationFileName, setverificationFileName] = useState<string>("");
  const [verificationFile, setVerificationFile] = useState<File | null>(null);

  const [correctFilePath, setCorrectFilePath] = useState<string>("");
  const [errorFilePath, setErrorFilePath] = useState<string>("");
  const [duplicatedFilePath, setDuplicatedFilePath] = useState<string>("");

  const [correctCount, setCorrectCount] = useState<number>(0);
  const [errorCount, setErrorCount] = useState<number>(0);
  const [duplicatedCount, setDuplicatedCount] = useState<number>(0);

  const [isverification, setisverification] = useState(false);


  useEffect(() => {
    const rawToken = AuthService.getRawToken();
    settoken(rawToken);
  }, []);
  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const handleRowSelect = (rowIndex: number, rowData: any[]) => {
    setSelectedRowIndex(rowIndex);
    setSelectedRowData(rowData);
  };

  const [SelectHeaderValue, setSelectHeaderValue] = useState<string | null>(
    null
  );
  useEffect(() => {
    if (token !== null) {

      setSelectHeaderValue(SelectValue);

    }
  }, [SelectValue]);


  useEffect(() => {
    if (token !== null) {
      setinvitationexcelData([["회원명", "핸드폰번호", "아이디"]]);
      for (let i = 0; i < 1000; i++) {
        setinvitationexcelData((prevData) => [...prevData, []]);
      }
      fetchinvitationWaitingMemberDataAPI();

    }
  }, [token]);

  const onMemberAllInvitationSendClick = () => {

    const confirmation = window.confirm("전체에게 초대장을 보내시겠습니까?");

    if (confirmation) {

      const newmodifiedData: string[][] = removeDuplicates(
        invitationexcelData
      ).filter((arr) => arr.length > 0);

      const modifiedData = newmodifiedData
        .filter((arr) => arr[2] !== null) // Filter out rows where "Member classification" is null
        .map((arr, index) => {
          if (index === 0) {
            // Find the index of "local_name" in the header row
            const local_nameIndex = arr.indexOf("아이디");

            // Reorder the headers with "local_name" at the end
            const reorderedHeaders = arr.filter(
              (header: any) => header !== "아이디"
            );
            return [...reorderedHeaders, "회원구분", "납부여부", "아이디"];
          }

          const [name, phone, local_name] = arr;

          const reorderedValues = [name, phone, "회원", "", local_name || ""];

          return reorderedValues;
        })
        .filter((arr) => arr.some((value) => value !== null && value !== ""));

      // console.log("신규초대 개수  :" + formatPhoneNumber(modifiedData).length)

      console.log(`${API_BASE_URL}/club/member/list/invite/noapp/noclub/${selectedClubInfo?.club_seq}?page=0&size=20000&sort=clubMemberSeq,desc`)
      fetch(
        `${API_BASE_URL}/club/member/list/invite/noapp/noclub/${selectedClubInfo?.club_seq}?page=0&size=20000&sort=clubMemberSeq,desc`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          // console.log(JSON.stringify(data, null, 2))
          // console.log(data.data.totalElements)
          // console.log("최종합 : " + (parseInt(data.data.totalElements) + (formatPhoneNumber(modifiedData).length - 1)));
          const datalength = (parseInt(data.data.totalElements) + (formatPhoneNumber(modifiedData).length - 1));


          if (datalength >= 200) {
            // console.log("totalElements가 200 이상입니다. 코드를 종료합니다.");
            window.alert("200명 이상 문자 발송은 담당자에게 문의 부탁드립니다. (rhyme@avchain.io)");
            return; // 코드 종료
          } else {


            // console.log("최종  : " + JSON.stringify(newmodifiedData, null, 2));
            setinvitationexcelData([]);
            setinvitationexcelData(newmodifiedData);
            for (let i = 0; i < 1000; i++) {
              setinvitationexcelData((prevData) => [...prevData, []]);
            }

            const did = selectdid[0];
            const clubId = selectedClubInfo?.club_seq;
            // console.log("초대리스트 : " + newmodifiedData);
            // console.log("did : " + did);
            // console.log("클럽번호 : " + clubId);



            const output = {
              did: did,
              clubId: clubId,
              excelData: formatPhoneNumber(modifiedData),
              sms: true,
              push: true,
              reInvite: true,
            };

            const contactSet = new Set(); // 중복된 연락처를 체크하기 위한 Set
            let duplication = false;

            // console.log("적용될 데이터 " + JSON.stringify(output, null, 2));
            let duplicationAlertShown = false;

            output.excelData.forEach((data: any) => {
              if (data) {
                const contact = data[1];
                if (contactSet.has(contact)) {
                  if (!duplicationAlertShown) {
                    window.alert(`중복항목이 있습니다: ${contact}`);
                    // console.log("(ExcelUpload) Check for duplicate contacts");
                    duplicationAlertShown = true;
                  }
                  duplication = true;
                } else {
                  contactSet.add(contact);
                }
              }
            });

            if (duplicationAlertShown === false) {
              // console.log("보내는값 : " + JSON.stringify(output));
              console.log(`${API_BASE_URL_ISSUER}/credential/club/excel/upload`)
              fetch(`${API_BASE_URL_ISSUER}/credential/club/excel/upload`, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(output),
              })
                .then((response) => {
                  if (!response.ok) {
                    throw new Error("(ExcelUpload) Network response was not ok");
                  }
                  return response.json();
                })
                .then((data) => {
                  alert("전체 초대장 발송이 완료되었습니다.");
                  setinvitationexcelData([["회원명", "핸드폰번호", "아이디"]]);
                  for (let i = 0; i < 1000; i++) {
                    setinvitationexcelData((prevData) => [...prevData, []]);
                  }
                  fetchinvitationWaitingMemberDataAPI();
                })
                .catch((error) => {
                  let errorMessage =
                    "초대장 발송이 되지않았습니다. 입력된 정보를 확인해주세요";

                  alert(errorMessage);
                  console.error("(ExcelUpload) Error:", error);
                });
            }


          }
        })


    }

  };
  const fetchinvitationWaitingMemberDataAPI = async () => {
    if (token !== null && selectedClubInfo?.club_seq !== undefined) {
      try {
        console.log(`${API_BASE_URL}/club/member/list/invite/${selectedClubInfo?.club_seq}?page=0&size=1000000&sort=clubInvitationSeq,desc`)
        const response = await fetch(
          `${API_BASE_URL}/club/member/list/invite/${selectedClubInfo?.club_seq}?page=0&size=1000000&sort=clubInvitationSeq,desc`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        const data = await response.json();
        // console.log("초대대기 " + JSON.stringify(data, null, 2));

        const excelHeader = ["회원명", "핸드폰번호", "아이디"];

        const excelRows = data.data.content.map((item: any) => {
          const { memberName, mobileNumber, localName, valid } = item;

          return { memberName, mobileNumber, localName, valid };
        });
        const filteredData = excelRows.filter(
          (item: any) => item.valid === true
        );

        const filteredData1 = filteredData.map((item: any) => {
          const { valid, ...rest } = item;
          return Object.fromEntries(Object.entries(rest));
        });

        const resultArray = [
          ...filteredData1.map((obj: any) => [
            obj.memberName,
            obj.mobileNumber,
            obj.localName,
          ]),
        ];


        // console.log("발급대기인원  :" + resultArray.length)
        setinvitationwaitingexcelDatacount(resultArray.length);
        setinvitationwaitingexcelData([excelHeader, ...resultArray]);
        for (let i = 0; i < 1000; i++) {
          setinvitationwaitingexcelData((prevData) => [...prevData, []]);
        }
      } catch (error) {
        console.error("(ExcelUpload) Error fetching data:", error);
      }
    }
  };
  function removeDuplicates(excelData: string[][]): string[][] {
    const seen = new Set<string>();

    const uniqueData = excelData.filter((row: string[], index: number) => {
      const key = JSON.stringify(row.slice(0, 2));
      const isDuplicate = seen.has(key);

      if (!isDuplicate) {
        seen.add(key);
        return true;
      }

      return false;
    });

    return uniqueData;
  }

  const uploadFile = async (file: File, jsonData: any) => {


    const confirmation = window.confirm("초대장을 보내시겠습니까?");

    if (confirmation) {
      try {



        const reader = new FileReader();

        reader.onload = (e: ProgressEvent<FileReader>) => {
          const target = e.target as FileReader;
          const data = new Uint8Array(target.result as ArrayBuffer);
          const workbook = XLSX.read(data, { type: 'array' });

          // 첫 번째 시트 선택
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];

          // 비어 있는 행의 개수를 셀 변수 선언
          let emptyRowCount = 0;

          // 시트의 데이터 파싱
          const sheetData: string[][] = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

          // 각 행의 데이터가 비어 있는지 확인하고 개수를 세기
          for (const row of sheetData) {
            let isEmptyRow = true;

            for (const cell of row) {
              if (cell !== "") {
                isEmptyRow = false;
                break;
              }
            }

            if (isEmptyRow) {
              emptyRowCount++;
            }
          }
          const rowCount = sheetData.length - emptyRowCount;
          if (rowCount > 200) {
            return;
          }
        };

        reader.readAsArrayBuffer(file); // 파일 읽기
        const formData = new FormData();
        const blob = new Blob([JSON.stringify(jsonData)], {
          type: "application/json",
        });
        formData.append('excelFile', file);
        formData.append("jsonExcelDataDto", blob);
        const response = await fetch(`${API_BASE_URL_ISSUER}/excel/file/upload`, {
          method: 'POST',
          body: formData,
        });

        if (response.ok) {
          console.log("파일 업로드 완료");
          message.info("파일 업로드 완료되었습니다.");

          for (let i = 0; i < 1000; i++) {
            setinvitationexcelData((prevData) => [...prevData, []]);
          }
          fetchinvitationWaitingMemberDataAPI();
          // 필요한 추가 작업을 수행할 수 있습니다.
        } else {
          console.log("파일 업로드 실패");
        }
      } catch (error) {
        console.log("파일 업로드 중 오류 발생:", error);
      }
    }


  };

  const handleFileUpload = async () => {
    try {
      // 파일 선택 창 열기
      const did = selectdid[0];
      const clubId = selectedClubInfo?.club_seq;
      const fileInput = document.createElement('input');
      // console.log("did : " + did)
      // console.log("clubId :" + clubId)
      fileInput.type = 'file';
      fileInput.accept = '.xlsx, .xls, .csv';
      fileInput.onchange = async (event) => {
        const fileList = (event.target as HTMLInputElement).files;
        if (fileList && fileList.length > 0) {
          const file = fileList[0];
          // JSON 데이터 생성


          const jsonData = {
            did: did,
            clubId: clubId,
            sms: true,
            push: true,
            reInvite: false,
            onlySaveSms: true
            // selectedClubInfo?.club_seq === 1297 || selectedClubInfo?.club_seq === 1246 || 
          };


          // console.log(JSON.stringify(jsonData, null, 2))

          // 파일 업로드 함수 호출
          await uploadFile(file, jsonData);
        }
      };
      fileInput.click();
    } catch (error) {
      console.log("파일 선택 창 열기 중 오류 발생:", error);
    }
  };
  function formatPhoneNumber(data: any) {
    const formattedData = data.map((row: any) => {
      if (
        row[1] !== undefined &&
        row[1] !== "" &&
        typeof row[1] === "string" &&
        row[1].includes("-")
      ) {
        row[1] = row[1].replace(/-/g, "");
      }
      return row;
    });

    return formattedData;
  }

  const onMemberNewInvitationSendClick = () => {

    const confirmation = window.confirm("초대장을 보내시겠습니까?");

    if (confirmation) {
      const newmodifiedData: string[][] = removeDuplicates(
        invitationexcelData
      ).filter((arr) => arr.length > 0);

      const modifiedData = newmodifiedData
        .filter((arr) => arr[2] !== null)
        .map((arr, index) => {
          if (index === 0) {
            const local_nameIndex = arr.indexOf("아이디");
            const reorderedHeaders = arr.filter(
              (header: any) => header !== "아이디"
            );
            return [...reorderedHeaders, "회원구분", "납부여부", "local_name"];
          }

          const [name, phone, local_name] = arr;

          const reorderedValues = [name, phone, "회원", "", local_name || ""];

          return reorderedValues;
        })
        .filter((arr) => arr.some((value) => value !== null && value !== ""));
      // console.log("신규초대 개수  :" + formatPhoneNumber(modifiedData).length)
      console.log(`${API_BASE_URL}/club/member/list/invite/noapp/noclub/${selectedClubInfo?.club_seq}?page=0&size=20000&sort=clubMemberSeq,desc`)
      fetch(
        `${API_BASE_URL}/club/member/list/invite/noapp/noclub/${selectedClubInfo?.club_seq}?page=0&size=20000&sort=clubMemberSeq,desc`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          // console.log(JSON.stringify(data, null, 2))
          // console.log("최종합 : " + (parseInt(data.data.totalElements) + (formatPhoneNumber(modifiedData).length - 1)));
          const datalength = (parseInt(data.data.totalElements) + (formatPhoneNumber(modifiedData).length - 1));
          if (datalength >= 200) {
            // console.log("totalElements가 200 이상입니다. 코드를 종료합니다.");
            window.alert("200명 이상 문자 발송은 담당자에게 문의 부탁드립니다. (rhyme@avchain.io)");
            return; // 코드 종료
          } else {


            setInvalidContacts([])

            setinvitationexcelData([]);
            setinvitationexcelData(newmodifiedData);
            for (let i = 0; i < 1000; i++) {
              setinvitationexcelData((prevData) => [...prevData, []]);
            }
            const did = selectdid[0];
            const clubId = selectedClubInfo?.club_seq;


            const output = {
              did: did,
              clubId: clubId,
              excelData: formatPhoneNumber(modifiedData),
              sms: true,
              push: true,
              reInvite: false,
              onlySaveSms: false,
              // selectedClubInfo?.club_seq === 1297 ||  selectedClubInfo?.club_seq === 1246 || 

            };

            if (modifiedData.length === 1) {
              return;
            }
            const contactSet = new Set();
            let duplication = false;

            // console.log("적용될 데이터 " + JSON.stringify(output, null, 2));
            // console.log("적용될 데이터개수 :  " + modifiedData.length);
            let duplicationAlertShown = false;

            output.excelData.forEach((data: any, index: number) => {
              if (data) {
                const contact = data[1];
                if (contactSet.has(contact)) {
                  if (!duplicationAlertShown) {
                    window.alert(`중복항목이 있습니다: ${contact}`);
                    duplicationAlertShown = true;
                  }
                  duplication = true;
                } else {
                  if (index !== 0 && data) {
                    if (contact.length === 11) {
                      if (!/^\d+$/.test(contact)) {
                        setInvalidContacts(prevInvalidContacts => [...prevInvalidContacts, index]);
                      } else {
                        contactSet.add(contact);
                      }
                    } else if (contact.length === 13) {
                      const regex = /^(?:\d{3}-\d{3,4}-\d{4}|\d{2,3}-\d{3,4}-\d{4})$/;
                      if (!regex.test(contact)) {
                        setInvalidContacts(prevInvalidContacts => [...prevInvalidContacts, index]);
                      } else {
                        contactSet.add(contact);
                      }
                    } else {
                      setInvalidContacts(prevInvalidContacts => [...prevInvalidContacts, index]);
                    }
                  }
                }
              }
            });

            console.log("올바르지 않은 전화번호가 포함된 행:", invalidContacts);
            if (duplicationAlertShown === false) {
              console.log(`${API_BASE_URL_ISSUER}/credential/club/excel/upload`)
              fetch(`${API_BASE_URL_ISSUER}/credential/club/excel/upload`, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(output, null, 2),
              })
                .then((response) => {
                  if (!response.ok) {
                    throw new Error("(ExcelUpload) Network response was not ok");
                  }
                  return response.json();
                })
                .then((data) => {
                  alert("초대장 발송이 완료되었습니다.");
                  setinvitationexcelData([["회원명", "핸드폰번호", "아이디"]]);
                  for (let i = 0; i < 1000; i++) {
                    setinvitationexcelData((prevData) => [...prevData, []]);
                  }
                  fetchinvitationWaitingMemberDataAPI();
                })
                .catch((error) => {
                  let errorMessage =
                    "초대장 발송이 되지않았습니다. 입력된 정보를 확인해주세요";

                  alert(errorMessage);
                  console.error("(ExcelUpload) Error:", error);
                });
            }
          }

        })


    }

  };
  const handleExcelrowClick = (value: any) => {
    // console.log("(ExcelUpload) 찾아온 데이터:", value);
    setSelectedValue(value);
  };
  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };
  const toggleverificationModal = () => {
    setverificationmodalOpen(!verificationmodalOpen);
  };
  const tempexcelfiledownload = () => {
    console.log("양식 파일 다운로드")
    // 엑셀 파일 경로
    const excelFilePath = '/asset/img/ExampleExcelFile.xlsx'; // 엑셀 파일의 경로를 정확히 지정해주세요.

    // a 태그를 동적으로 생성하여 다운로드 링크 설정
    const link = document.createElement('a');
    link.href = excelFilePath;
    link.download = 'RhymeCard양식파일.xlsx'; // 다운로드될 파일의 이름 설정
    document.body.appendChild(link);

    // 다운로드 링크 클릭
    link.click();

    // 다운로드 링크 제거
    document.body.removeChild(link);

  };
  const verification = () => {
    console.log("데이터검증실행")
    const formData = new FormData();

    const memberData = {
      clubSeq: selectedClubInfo?.club_seq,
      clubName: selectedClubInfo?.club_name,
    };
    // console.log("#새소식 등록 정보" + JSON.stringify(memberData, null, 2));
    const jsonBlob = new Blob([JSON.stringify(memberData)], {
      type: "application/json",
    });

    formData.append("verifyExcelDto", jsonBlob);

    // console.log("이미지여부  :" + noticeselectedImage);
    if (verificationFile === null) {
      // console.log("이미지없음 ")
      const emptyBlob = new Blob([], { type: "excel/xlsx" });
      const emptyImageFile = new File([emptyBlob], "empty_excel.xlsx", {
        type: "excel/xlsx",
      });
      formData.append("excelFile", emptyImageFile, "excel.xlsx");

    } else {
      formData.append("excelFile", verificationFile);
      setisverification(true)


    }

    // console.log("토큰@@@@ :" + token + "//");
    console.log(`${API_BASE_URL_ISSUER}/excel/file/verify`)
    fetch(`${API_BASE_URL_ISSUER}/excel/file/verify`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {

        console.log(JSON.stringify(data, null, 2))
        setCorrectFilePath(data.data.correctDataPath);
        setErrorFilePath(data.data.errorDataPath);
        setDuplicatedFilePath(data.data.duplicatedDataPath);

        setCorrectCount(data.data.correctDataCount);
        setErrorCount(data.data.errorDataCount);
        setDuplicatedCount(data.data.duplicatedDataCount);

        window.alert("검증요청되었습니다. ");
      })
      .catch((error) => {
        console.error("(ExcelUpload) Error:", error);
      });

  }
  const handleDownload = (FilePath: string) => {
    console.log("클릭 ")
    const formData: {
      path: String;
      clubSeq: any;
    } = {
      path: FilePath,
      clubSeq: selectedClubInfo?.club_seq
    };
    // console.log("클럽번호 : " + selectedClubInfo?.club_seq)
    // console.log("파일경로 : " + JSON.stringify(formData))
    // console.log("토큰확인 : " + token)

    fetch(`${API_BASE_URL_ISSUER}/excel/file/download`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        // Check if response is successful
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        // Return blob data
        return response.blob();
      })
      .then((blob) => {
        // Create object URL for the blob
        const url = window.URL.createObjectURL(blob);

        // Create a temporary anchor element
        const a = document.createElement('a');
        a.style.display = 'none';
        document.body.appendChild(a);

        // Set the URL and download attribute for the anchor element
        a.href = url;
        a.download = FilePath.split('/').pop() + "";

        // Trigger click event to start download
        a.click();

        // Clean up
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      })
      .catch((error) => {
        console.error('(ExcelUpload) Error:', error);
      });
  };

  const verificationFileUpload = () => {
    console.log("파일선택")
    try {
      // 파일 선택 창 열기
      const fileInput = document.createElement('input');

      fileInput.type = 'file';
      fileInput.accept = '.xlsx, .xls, .csv';
      fileInput.onchange = async (event) => {
        const fileList = (event.target as HTMLInputElement).files;
        if (fileList && fileList.length > 0) {
          const file = fileList[0];
          // JSON 데이터 생성
          console.log("선택한 파일 : " + file.name)
          setverificationFileName(file.name)
          setVerificationFile(file);

        }
      };
      fileInput.click();
    } catch (error) {
      console.log("파일 선택 창 열기 중 오류 발생:", error);
    }
  };
  const onMemberSaveInvitationSendClick = () => {
    const confirmation = window.confirm("초대장을 저장하시겠습니까?");

    if (confirmation) {

      console.log(`${API_BASE_URL}/club/member/list/invite/noapp/noclub/${selectedClubInfo?.club_seq}?page=0&size=20000&sort=clubMemberSeq,desc`)
      fetch(
        `${API_BASE_URL}/club/member/list/invite/noapp/noclub/${selectedClubInfo?.club_seq}?page=0&size=20000&sort=clubMemberSeq,desc`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          // console.log(JSON.stringify(data, null, 2))
          // console.log(data.data.totalElements)
          const newmodifiedData: string[][] = removeDuplicates(
            invitationexcelData
          ).filter((arr) => arr.length > 0);
          setinvitationexcelData([]);
          setinvitationexcelData(newmodifiedData);
          for (let i = 0; i < 1000; i++) {
            setinvitationexcelData((prevData) => [...prevData, []]);
          }

          const did = selectdid[0];
          const clubId = selectedClubInfo?.club_seq;
          const modifiedData = newmodifiedData
            .filter((arr) => arr[2] !== null)
            .map((arr, index) => {
              if (index === 0) {
                const local_nameIndex = arr.indexOf("아이디");

                const reorderedHeaders = arr.filter(
                  (header: any) => header !== "아이디"
                );
                return [...reorderedHeaders, "회원구분", "납부여부", "local_name"];
              }

              const [name, phone, local_name] = arr;

              const reorderedValues = [name, phone, "회원", "", local_name || ""];

              return reorderedValues;
            })
            .filter((arr) => arr.some((value) => value !== null && value !== ""));
          // console.log("보낼리스트 : " + modifiedData.length);
          const output = {
            did: did,
            clubId: clubId,
            excelData: formatPhoneNumber(modifiedData),
            sms: true,
            push: true,
            reInvite: false,
            onlySaveSms: true
          };

          if (modifiedData.length === 1) {
            return; // Stop the execution of the function
          }

          const contactSet = new Set(); // 중복된 연락처를 체크하기 위한 Set
          let duplication = false;

          // console.log("적용될 데이터 " + JSON.stringify(output, null, 2));
          let duplicationAlertShown = false;

          output.excelData.forEach((data: any) => {
            if (data) {
              const contact = data[1];
              if (contactSet.has(contact)) {
                if (!duplicationAlertShown) {
                  window.alert(`중복항목이 있습니다: ${contact}`);
                  // console.log("(ExcelUpload) Check for duplicate contacts");
                  duplicationAlertShown = true;
                }
                duplication = true;
              } else {
                contactSet.add(contact);
              }
            }
          });

          if (duplicationAlertShown === false) {
            console.log(`${API_BASE_URL_ISSUER}/credential/club/excel/upload`)
            fetch(`${API_BASE_URL_ISSUER}/credential/club/excel/upload`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(output, null, 2),
            })
              .then((response) => {
                if (!response.ok) {
                  throw new Error("(ExcelUpload) Network response was not ok");
                }
                return response.json();
              })
              .then((data) => {
                alert("초대장 저장이 완료되었습니다.");
                // console.log("(ExcelUpload) Success:", data);
                setinvitationexcelData([["회원명", "핸드폰번호", "아이디"]]);
                for (let i = 0; i < 1000; i++) {
                  setinvitationexcelData((prevData) => [...prevData, []]);
                }
                fetchinvitationWaitingMemberDataAPI();
              })
              .catch((error) => {
                let errorMessage =
                  "초대장 발송이 되지않았습니다. 입력된 정보를 확인해주세요";

                alert(errorMessage);
                console.error("(ExcelUpload) Error:", error);
              });
          }

        })
    }
  };
  return (

    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", padding: "20px" }}>
      <div style={{ fontSize: "24px" }}>
        | { } 초대
      </div>
      <div style={{ width: "100%", display: "flex", alignItems: "center" }}>

        <Button
          style={{
            cursor: "pointer",
            width: "200px",
            height: "40px",
            margin: "15px",
            borderRadius: "10px",
            backgroundColor: "#2D5478",
            border: "1px solid #2D5478",
            color: "white",
          }}
          onClick={onMemberNewInvitationSendClick}
          title="신규 회원에게 초대장을 발송합니다. (SMS/PUSH가 발송됩니다.)"
        >
          신규 초대자께 초대장 보내기
        </Button>
        {/* <Button
          onClick={handleFileUpload}
          style={{
            cursor: "pointer",
            width: "200px",
            height: "40px",
            margin: "15px",
            borderRadius: "10px",
            backgroundColor: "#2D5478",
            border: "1px solid #2D5478",
            color: "white",
          }}
          title="엑셀 파일을 올려주세요"
          icon={<UploadOutlined />}
        >
          파일로 초대명단 올리기
        </Button> */}

        <Button
          style={{
            cursor: "pointer",
            width: "150px",
            height: "40px",
            margin: "15px",
            borderRadius: "10px",
            backgroundColor: "#2D5478",
            border: "1px solid #2D5478",
            color: "white",
          }}
          onClick={onMemberSaveInvitationSendClick}
          title="신규 회원과 기존의 발급 대기중인 회원에 초대장을 저장합니다. (SMS/PUSH가 발송 되지않습니다.)"
        >
          초대장 생성하기
        </Button>
        <Button
          onClick={toggleverificationModal}
          style={{
            cursor: "pointer",
            width: "200px",
            height: "40px",
            margin: "15px",
            borderRadius: "10px",
            backgroundColor: "#2D5478",
            border: "1px solid #2D5478",
            color: "white",
          }}
          title="엑셀 파일을 올려주세요"
          icon={<UploadOutlined />}
        >
          파일업로드 및 검증하기
        </Button>
        <Button
          style={{
            cursor: "pointer",
            width: "40px",
            height: "40px",
            marginLeft: "15px",
            fontSize: "30px",
            borderRadius: "100px",
            backgroundColor: "white",
            border: "1px solid white",
            color: "#123758",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={toggleModal}
          title="회원초대 사용방법을 알려드립니다."
        >
          <FontAwesomeIcon icon={faQuestionCircle} style={{}} />
        </Button>

        {/* width <= 1600 ? "500px" : "800px", */}


        <div
          style={{
            width: "800px",
            height: "100px",
            textAlign: "left",
            paddingTop: "30px",
            marginLeft: "50px",
            display: "flex",
            
            justifyContent: width <= 1600 ? "flex-start" : "flex-end", // 오른쪽 정렬
            alignItems: "center", // 세로 가운데 정렬
          }}
        >
          <button
            style={{
              cursor: "pointer",
              width: "150px",
              height: "50px",
              margin: "15px",
              borderRadius: "10px",
              backgroundColor: "#2D5478",
              border: "1px solid #2D5478", // Set border color and thickness
              color: "white",
            }}
            onClick={onMemberAllInvitationSendClick}
            title="신규 회원과 기존의 발급 대기중인 회원에 초대장을 발송합니다. (SMS/PUSH가 발송됩니다.)"
          >
            발급 대기중인 회원께<br /> 초대장 보내기
          </button>
        </div>

        {modalOpen && (
          <Modal
            title="회원 초대 사용방법"
            open={modalOpen}
            onCancel={toggleModal}
            width={800}
            footer={null}
          >
            <p>1. 신규 초대 회원에 회원리스트를 입력하거나 복사하여 붙여넣어주세요.</p>
            <p>2. 신규 초대자께 초대장 보내기 버튼을 클릭하면 신규 초대 회원에게 SMS/Push를 전송합니다.</p>
            <p>3. 전체 초대장 발송 버튼을 클릭하면 신규 초대 회원과, 발급 대기중인 회원에게 SMS/Push를 전송합니다.</p>
            <p>4. 초대장 생성하기 버튼을 클릭하면 신규 초대 회원에게 SMS/Push를 전송하지않고 저장합니다.</p>
          </Modal>
        )}

        {verificationmodalOpen && (
          <Modal
            title="파일업로드"
            open={verificationmodalOpen}
            onCancel={toggleverificationModal}
            width={1000}
            footer={null}
          >

            <div style={{ display: "flex", justifyContent: "center" }}>
              <div style={{ width: "50%", borderRight: "2px solid black", padding: "20px" }}>
                <p>1. 양식 파일 다운로드 후 아래와 같은 양식에 맞춰 엑셀 파일 저장</p>
                <img
                  src="asset/img/excelex.png"
                  alt="Excel"
                  style={{
                    width: "400px",
                    height: "200px",
                  }}
                />
                <Button
                  style={{
                    cursor: "pointer",
                    width: "150px",
                    height: "40px",
                    margin: "15px",
                    borderRadius: "10px",
                    backgroundColor: "#2D5478",
                    border: "1px solid #2D5478",
                    color: "white",
                  }}
                  onClick={tempexcelfiledownload}
                >
                  양식파일 다운로드
                </Button>
                <p>2. 양식에 맞춰 작성한 엑셀 파일 업로드 후 데이터 검증</p>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div
                    style={{
                      backgroundColor: "lightgrey",
                      height: "40px",
                      width: "calc(100% - 180px)", /* 버튼과 박스 너비의 합이 전체 너비가 되도록 설정 */
                      borderRadius: "10px 0 0 10px", /* 좌측 상단 및 좌측 하단 테두리만 둥글게 설정 */
                      display: "flex", /* 플렉스 컨테이너 설정 */
                      alignItems: "center", /* 수직 중앙 정렬 */
                      justifyContent: "center", /* 수평 중앙 정렬 */
                    }}
                  >
                    {verificationFileName}
                  </div>
                  <Button
                    style={{
                      cursor: "pointer",
                      width: "150px",
                      height: "40px",
                      margin: "0", /* 상하 여백을 없애기 위해 0으로 설정 */
                      borderRadius: "0 10px 10px 0", /* 우측 상단 및 우측 하단 테두리만 둥글게 설정 */
                      backgroundColor: "#2D5478",
                      border: "1px solid #2D5478",
                      color: "white",
                    }}
                    onClick={verificationFileUpload}
                  >
                    파일선택
                  </Button>
                </div>

                {verificationFileName && (
                  <p style={{ marginTop: "15px" }}>파일 업로드가 완료되었습니다. 아래의 데이터 검증 버튼을 눌러주세요</p>
                )}
                <Button
                  style={{
                    cursor: "pointer",
                    width: "150px",
                    height: "40px",
                    margin: "15px",
                    borderRadius: "10px",
                    backgroundColor: "#2D5478",
                    border: "1px solid #2D5478",
                    color: "white",
                  }}
                  onClick={verification}
                >
                  데이터 검증

                </Button>
              </div>
              <div style={{ width: "50%", padding: "20px" }}>
                <p>3. 조회된 파일을 선택하여 다운로드</p>
                <p>검증 결과</p>


                <div style={{ border: "1px solid black", padding: "10px" }}>
                  <p>정상 데이터: {correctCount}건</p>
                  <div style={{ backgroundColor: "lightgrey", borderRadius: "50px", padding: "10px", margin: "10px 0", width: "300px", height: "40px" }}>
                    <a style={{ display: isverification ? "" : "none" }} onClick={() => handleDownload(correctFilePath)} download="correct.xlsx">correct.xlsx</a>
                  </div>
                  <p>오류 데이터: {errorCount}건 (비정상적인 전화번호)</p>
                  <div style={{ backgroundColor: "lightgrey", borderRadius: "50px", padding: "10px", margin: "10px 0", width: "300px", height: "40px" }}>
                    <a style={{ display: isverification ? "" : "none" }} onClick={() => handleDownload(errorFilePath)} download="error.xlsx">error.xlsx</a>
                  </div>
                  <p>중복 데이터: {duplicatedCount}건 (같은 번호 내 이름이 여러개 등록된 데이터)</p>
                  <div style={{ backgroundColor: "lightgrey", borderRadius: "50px", padding: "10px", margin: "10px 0", width: "300px", height: "40px" }}>
                    <a style={{ display: isverification ? "" : "none" }} onClick={() => handleDownload(duplicatedFilePath)} download="duplicated.xlsx">duplicated.xlsx</a>
                  </div>
                </div>
                <p>4. 데이터 최종 업로드 버튼을 클릭 후 다운로드받은 정상데이터 업로드</p>
                <Button
                  style={{
                    cursor: "pointer",
                    width: "150px",
                    height: "40px",
                    margin: "15px",
                    borderRadius: "10px",
                    backgroundColor: "#2D5478",
                    border: "1px solid #2D5478",
                    color: "white",
                  }}
                  onClick={handleFileUpload}
                >
                  데이터 최종 업로드
                </Button>
                {/* 
                {uploadStatus === "completed" && (
                  <p>파일 업로드가 완료되었습니다. 아래 데이터 검증 버튼을 눌러주세요.</p>
                )}
                {verificationResult && (
                  <div>
                    <p>검증 결과</p>
                    <p>정상 데이터: {verificationResult.normalCount}건</p>
                    <p>오류 데이터: {verificationResult.errorCount}건 ({verificationResult.errorType})</p>
                    <p>중복 데이터: {verificationResult.duplicateCount}건 ({verificationResult.duplicateType})</p>
                  </div>
                )} */}
                {/* <Button
                  style={{
                    cursor: "pointer",
                    width: "200px",
                    height: "40px",
                    margin: "15px",
                    borderRadius: "10px",
                    backgroundColor: "#2D5478",
                    border: "1px solid #2D5478",
                    color: "white",
                  }}
                  onClick={verifyData}
                >
                  데이터 검증
                </Button>
                {verificationResult && (
                  <Button
                    style={{
                      cursor: "pointer",
                      width: "200px",
                      height: "40px",
                      margin: "15px",
                      borderRadius: "10px",
                      backgroundColor: "#2D5478",
                      border: "1px solid #2D5478",
                      color: "white",
                    }}
                    onClick={uploadData}
                  >
                    데이터 최종 업로드
                  </Button>
                )} */}
              </div>
            </div>
          </Modal>
        )}




      </div>


      <div style={{ width: "100%", display: "flex" }}>
        <div style={{ width: "50%" }}>
          <div
            style={{
              textAlign: "left",
              fontSize: "30px",
              padding: "30px",
            }}
          >
            신규 초대 회원
          </div>
          <div
            style={{
              width: "100%",
              height: width <= 1600 ? "500px" : "800px",
              display: "flex",
            }}
          >
            <div
              style={{
                width: "100%",
                height: width <= 1600 ? "500px" : "800px"
              }}
            >
              <InviteExcelView
                data={invitationexcelData}
                addition={addition || 0}
                membercount={membercount || 0}
                SelectValue={SelectHeaderValue || ""}
                invalidContacts={invalidContacts || ""}
                onRowSelect={handleRowSelect}
                onExcelrowClick={handleExcelrowClick}
              />
            </div>

          </div>
        </div>



        <div style={{ width: "50%" }}>
          <div
            style={{
              textAlign: "left",
              fontSize: "30px",
              padding: "30px",
            }}
          >
            발급 대기중인 회원 ({invitationwaitingexcelDatacount}명)
          </div>
          <div
            style={{
              width: "100%",
              height: width <= 1600 ? "500px" : "800px"
            }}
          >
            <InviteWaitExcelView
              data={invitationwaitingexcelData}
              addition={addition || 0}
              membercount={membercount || 0}
              SelectValue={SelectHeaderValue || ""}
              onRowSelect={handleRowSelect}
              onExcelrowClick={handleExcelrowClick}
            />
          </div>
        </div>








      </div>

    </div>


  );

};

export default InvitationView;
